import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core'
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms'
import { MatPaginator, PageEvent } from '@angular/material/paginator'
import { itemsEntityName } from '@galabid/gb-dashboard/item/data-access'
import { ColumnTypeEnum } from '@galabid/gb-dashboard/shared/feature'
import { UntilDestroy } from '@ngneat/until-destroy'
import { EnvironmentModel } from 'apps/gb-dashboard/src/environments/environment.model'
import { APP_CONFIG } from 'libs/shared/app-config/src/lib/gb-app-config'
import { map, of } from 'rxjs'
import { GbEditCategoryStore } from './gb-edit-category.store'

@UntilDestroy()
@Component({
  selector: 'gb-edit-category',
  templateUrl: './gb-edit-category.component.html',
  styleUrls: ['./gb-edit-category.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [GbEditCategoryStore],
  standalone: false,
})
export class GbEditCategoryComponent {
  @Output() itemsSelect = new EventEmitter<string[]>()
  @Output() labelUpdate = new EventEmitter<string>()

  @Input() selectedItems: string[] = []

  @Input() set markFormAsTouched(value: any) {
    if (value) this.categoryForm.markAllAsTouched()
  }

  @ViewChild('paginator') paginator!: MatPaginator

  categoryFormFields: { [key: string]: AbstractControl | FormControl } = {
    label: new FormControl('', [Validators.required]),
  }

  public categoryForm = new FormGroup(this.categoryFormFields)

  loaded$ = this.gbEditCategoryStore.loaded$
  count$ = this.gbEditCategoryStore.count$
  limit$ = this.gbEditCategoryStore.limit$
  items$ = this.gbEditCategoryStore.items$

  displayColumns$ = of([
    {
      columnKey: 'name',
      columnLabel: 'ITEMS.LIST.NAME',
      columnType: ColumnTypeEnum.Label,
    },
    {
      columnKey: 'item_type',
      columnLabel: 'ITEMS.LIST.TYPE',
      columnType: ColumnTypeEnum.Template,
    },
  ])

  itemsEntityName = itemsEntityName
  limit = this.appConfig.itemsPageSize
  offset = 0

  get label() {
    return this.categoryForm.get('label') as AbstractControl<string>
  }

  constructor(
    private gbEditCategoryStore: GbEditCategoryStore,
    @Inject(APP_CONFIG) protected appConfig: EnvironmentModel,
  ) {}

  ngOnInit(): void {
    this.gbEditCategoryStore.loadFirstPageItems()
  }

  getDisplayColumns$(itemType: TemplateRef<any>) {
    return this.displayColumns$.pipe(
      map((columns) =>
        columns.map((column) => (column.columnKey === 'item_type' ? { ...column, columnTemplate: itemType } : column)),
      ),
    )
  }

  onPageChange(event: PageEvent): void {
    this.gbEditCategoryStore.loadNextPageItems({
      offset: event.pageIndex * event.pageSize,
      limit: event.pageSize,
    })
  }

  onSearch(search: string): void {
    this.paginator.firstPage()
    this.gbEditCategoryStore.searchItems(search)
  }

  onCheckboxChange(event: string[]): void {
    this.selectedItems = event
    this.itemsSelect.emit(this.selectedItems)
  }
}
